
import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button }from '@cmsgov/design-system';


// Components

import ModalHeader from '@common-components/headers/ModalHeader';

// Constants

import { configs } from '@constants/configs/configs';
import { useToggle } from '@hooks/useToggle';
import { useNavigate } from 'react-router-dom';


const SsapExitModal = props => {

    const {
        actions: {
            hideModal
        },
        bottomAnchors: [
            anchor_1,
        ],
        boundAnchor,
        modal: {
            modalData: {
                callback,
            }
        },
        modalHeaderProps
    } = props;
    
    const navigate = useNavigate();
    
    const [ isDisabled, toggle ] = useToggle(false);

    const redirectToDashboard = () => {
        navigate(configs.routes.INDPORTAL);
        hideModal();
    };

    const handleHideClick = (): void => {
        toggle();
        callback({ failCallback: hideModal }, hideModal);
    };

    const handleRightBtnClick = (): void => {
        toggle();
        callback({ blockerCallback: redirectToDashboard, failCallback: hideModal }, hideModal);
    };

    return (
        <Fragment>
            <div className="gi-modal__header__head">
                <ModalHeader { ...(isDisabled ? { ...modalHeaderProps, hideModal: () => {} } : modalHeaderProps) } />
            </div>
            <div className="gi-modal__body txt-left" id = 'ssapExitModal'>
                <FormattedMessage
                    id='modals.are_you_sure_exit_ssap'
                    tagName='p'
                    values={{ lineBreak: <br/> }}
                />
            </div>
            <div className='gi-modal__controls'>
                <Button
                    className='usa-button usa-button--outline gi-button gi-button__outline'
                    disabled={isDisabled}
                    onClick={handleHideClick}
                >
                    <FormattedMessage id='button.no'/>
                </Button>
                <Button
                    className='usa-button gi-button gi-button__primary'
                    disabled={isDisabled}
                    onClick={handleRightBtnClick}
                    inputRef={boundAnchor(anchor_1)}
                >
                    <FormattedMessage id='button.yes'/>
                </Button>
            </div>
        </Fragment>
    );

};

export default SsapExitModal;